module.exports = __webpack_public_path__ + "img/sz2.7328feec.png";